var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMetaNetwork = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.132 .25)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.533,
    y: 0.563,
    width: 11.99,
    height: 12.656,
    rx: 3,
    strokeWidth: 1.5,
    stroke: "#80838d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b9bbc6",
    strokeWidth: 1.5,
    d: "M9.725 3.516H3.331c-.442 0-.8.377-.8.843v3.375c0 .466.358.844.8.844h1.598v.844c0 .466.358.844.8.844h1.598c.442 0 .8-.378.8-.844v-.844h1.598c.442 0 .8-.378.8-.844V4.36c0-.466-.358-.843-.8-.843zM6.528 3.516v2.109M4.53 3.516v2.109M8.526 3.516v2.109"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMetaNetwork, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/meta-network.a2c1c615.svg";
export { ForwardRef as ReactComponent };